// frontend/src/components/ManageAccounts.js
import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase'; // Fix: Import auth to access prototype methods
import { collection, getDocs, addDoc, deleteDoc, updateDoc, doc, setDoc, getDoc } from 'firebase/firestore';
import axios from 'axios'; 
import { useAuth } from '../contexts/AuthContext'; // Fix: Import useAuth

export default function ManageAccounts() {
    const { currentUser } = useAuth(); // Fix: Get currentUser from context
    const [accounts, setAccounts] = useState([]);
    const [modelGroups, setModelGroups] = useState([]);
    const [platforms, setPlatforms] = useState([]); 
    const [adsProfiles, setAdsProfiles] = useState([]); 
    const [activeSessions, setActiveSessions] = useState([]); 
    const [pausedSessions, setPausedSessions] = useState([]);
    const [debugPayloads, setDebugPayloads] = useState({});
    const [visibleLogs, setVisibleLogs] = useState([]); // Tracks which logs are expanded // Stores the exact API body

    // --- SYNC STATUS WITH BACKEND ---
    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
                
                // 1. Get Workers
                try {
                    const wRes = await axios.get(`${API_URL}/api/worker/list`);
                    setWorkers(wRes.data.workers.sort((a, b) => Number(b.is_online) - Number(a.is_online)));
                } catch (e) { console.log("Worker list error", e); }

                // Call the /status endpoint we created
                const res = await axios.get(`${API_URL}/status`);
                const sessions = res.data.active_sessions || {};
                const payloads = res.data.debug_payloads || {};
                
                // Calculate which IDs are active and which are paused
                const runningIds = Object.keys(sessions);
                const pausedIds = runningIds.filter(id => sessions[id] === 'paused');
                
                // Update React State
                setActiveSessions(runningIds);
                setPausedSessions(pausedIds);
                setDebugPayloads(payloads);
            } catch (err) {
                console.error("Status Sync Error:", err);
            }
        };

        // Run immediately and then every 2 seconds
        fetchStatus();
        const interval = setInterval(fetchStatus, 2000);
        return () => clearInterval(interval);
    }, []);

    // Helper: Check Status
    const checkStatus = async () => {
        try {
            const res = await axios.get('http://127.0.0.1:8000/api/adspower/status');
            setActiveSessions(res.data.active);
        } catch (e) { console.error("Status check failed", e); }
    };

    // Poll status every 5s
    useEffect(() => {
        const interval = setInterval(checkStatus, 5000);
        checkStatus(); // Initial
        return () => clearInterval(interval);
    }, []);

    // Helper: Pause/Resume
    const togglePause = async (acc) => {
        const isPaused = pausedSessions.includes(acc.id);
        const endpoint = isPaused ? 'resume' : 'pause';
        
        try {
            await axios.post(`http://127.0.0.1:8000/api/adspower/${endpoint}`, {
                account_id: acc.id,
                adspower_id: acc.adspowerId
            });
            // Optimistic update
            if (isPaused) {
                setPausedSessions(prev => prev.filter(id => id !== acc.id));
            } else {
                setPausedSessions(prev => [...prev, acc.id]);
            }
        } catch (e) { alert(e.message); }
    };

    // Helper: Toggle Log Visibility
    const toggleLog = (id) => {
        setVisibleLogs(prev => prev.includes(id) 
            ? prev.filter(x => x !== id) 
            : [...prev, id]
        );
    };

    // Helper: Toggle Run
    const toggleBot = async (acc) => {
        if (!acc.adspowerId) {
            alert("Link an Adspower Profile first!");
            return;
        }
        
        const isRunning = activeSessions.includes(acc.id);
        
        try {
            if (isRunning) {
                // STOP
                await axios.post(`http://127.0.0.1:8000/api/adspower/stop`, {
                    account_id: acc.id,
                    adspower_id: acc.adspowerId
                });
            } else {
                // START - Gather Config
                // 1. Get API Key & Model
                const apiKey = localStorage.getItem('shield_api_key') || '';
                // PRIORITY: Account Model > Global Sandbox Model > Default (Llama 3.3 70B)
                const model = acc.model || localStorage.getItem('shield_model') || 'meta-llama/llama-3.3-70b-instruct:free';
                
                if (!apiKey) {
                    if(!window.confirm("⚠️ No API Key found in Sandbox settings. Bot will be silent. Continue?")) return;
                }

                // 2. Get System Prompt (Default or Custom)
                let sysPrompt = "";
                const sysDoc = await getDoc(doc(db, "settings", "system_prompt"));
                if (sysDoc.exists()) {
                    sysPrompt = sysDoc.data().text;
                } else {
                    // Fallback
                    sysPrompt = "You are ((ModelName)), ((ModelAge))F from ((ModelLocation))..."; 
                }

                // 3. Variables
                const vars = {
                    ModelName: acc.name,
                    ModelAge: acc.age,
                    ModelLocation: acc.location,
                    TelegramHandle: acc.tgHandle,
                    Platform: acc.platform,
                    ModelPersona: acc.persona
                };

                // Get Token (Fix: Use auth.currentUser directly)
                const token = auth.currentUser ? await auth.currentUser.getIdToken() : "";
                
                await axios.post(`http://127.0.0.1:8000/api/adspower/start`, {
                    account_id: acc.id,
                    adspower_id: acc.adspowerId,
                    apiKey: apiKey,
                    model: model,
                    firebaseToken: token, // Pass token to backend
                    systemPrompt: sysPrompt,
                    templateVariables: vars
                });
            }
            checkStatus(); 
        } catch (e) {
            alert(`Error: ${e.response?.data?.detail || e.message}`);
        }
    };
    
    // Worker State
    const [workers, setWorkers] = useState([]);

    // Create State
    const [createForm, setCreateForm] = useState({
        modelId: '', platform: '', adspowerId: '', name: '', age: '19', location: 'Chicago', tgHandle: '', model: '', persona: 'Lazy High Value.'
    });

    // UI State
    const [loading, setLoading] = useState(false);
    const [editingAccount, setEditingAccount] = useState(null); // The object being edited

    // Fetch Data
    const fetchData = async () => {
        const gSnap = await getDocs(collection(db, "models"));
        const gList = []; gSnap.forEach(d => gList.push(d.data()));
        setModelGroups(gList);

        const aSnap = await getDocs(collection(db, "accounts"));
        const aList = []; aSnap.forEach(d => aList.push({ id: d.id, ...d.data() }));
        setAccounts(aList);

        // Fetch Platforms
        const pDoc = await getDoc(doc(db, "settings", "platforms"));
        if (pDoc.exists()) {
            setPlatforms(pDoc.data().list || ['Emerald Chat']);
        } else {
            setPlatforms(['Emerald Chat']); 
        }

        // Fetch Adspower Profiles
        const adDoc = await getDoc(doc(db, "settings", "adspower_profiles"));
        if (adDoc.exists()) setAdsProfiles(adDoc.data().list || []);
    };

    useEffect(() => { fetchData(); }, [loading]);

    // Helper: Add New Platform
    const handleAddPlatform = async () => {
        const newP = prompt("Enter new Platform Name (e.g. Tinder):");
        if (!newP) return;
        
        const updatedList = [...platforms, newP];
        setPlatforms(updatedList);
        
        // Save to DB
        await setDoc(doc(db, "settings", "platforms"), { list: updatedList });
    };

    // --- ACTIONS ---
    const handleCreate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await addDoc(collection(db, "accounts"), { ...createForm, createdAt: new Date() });
            // Reset form but keep platform/model for easier bulk creation if needed? No, reset all.
            setCreateForm({ modelId: '', platform: '', adspowerId: '', name: '', age: '19', location: 'Chicago', tgHandle: '', persona: 'Lazy High Value.' });
        } catch (error) { alert(error.message); }
        setLoading(false);
    };

    const handleSaveEdit = async () => {
        setLoading(true);
        try {
            // Update only the fields allowed
            await updateDoc(doc(db, "accounts", editingAccount.id), {
                modelId: editingAccount.modelId,
                platform: editingAccount.platform,
                adspowerId: editingAccount.adspowerId || '', // Update link
                name: editingAccount.name,
                age: editingAccount.age,
                location: editingAccount.location,
                tgHandle: editingAccount.tgHandle,
                model: editingAccount.model || '',
                persona: editingAccount.persona
            });
            setEditingAccount(null);
        } catch (error) { alert(error.message); }
        setLoading(false);
    };

    const handleDelete = async () => {
        if (!window.confirm("Delete this account permanently?")) return;
        setLoading(true);
        await deleteDoc(doc(db, "accounts", editingAccount.id));
        setEditingAccount(null);
        setLoading(false);
    };

    const API_URL = process.env.REACT_APP_API_URL || "https://shield-backend-478066517622.us-central1.run.app";

    return (
        <div className="admin-container">
            {/* WORKER STATUS HEADER */}
            <div style={{ background: '#111', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #333' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <h3 style={{ margin: 0, color: '#e0e0e0' }}>🖥️ Connected Workers</h3>
                    <a href={`${API_URL}/api/worker/download-installer`} style={{ ...btnStyle, background: '#ff9800', color: 'black', textDecoration: 'none', fontWeight: 'bold' }}>
                        🔌 Connect This PC
                    </a>
                </div>
                
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {workers.length === 0 && <span style={{ color: '#666', fontStyle: 'italic' }}>No workers found. Download the installer to connect.</span>}
                    {workers.map(w => (
                        <div key={w.id} style={{ 
                            padding: '8px 15px', 
                            background: '#252526', 
                            borderRadius: '5px', 
                            border: w.is_online ? '1px solid #00ff00' : '1px solid #555',
                            display: 'flex', alignItems: 'center', gap: '8px'
                        }}>
                            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: w.is_online ? '#00ff00' : 'red' }}></div>
                            <strong>{w.id}</strong>
                            <span style={{ fontSize: '0.8rem', color: '#888' }}>{w.is_online ? 'ONLINE' : 'OFFLINE'}</span>
                        </div>
                    ))}
                </div>
            </div>

            <h2>Manage Accounts</h2>

            <div style={{ display: 'flex', gap: '20px' }}>
                {/* Creator (Left Panel) */}
                <div style={{ flex: 1, background: '#252526', padding: '20px', borderRadius: '8px', height: 'fit-content' }}>
                    <h3>Create Account</h3>
                    <form onSubmit={handleCreate} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <select 
                            value={createForm.modelId} onChange={e => setCreateForm({...createForm, modelId: e.target.value})} required
                            style={inputStyle}>
                            <option value="">-- Select Parent Group --</option>
                            {modelGroups.map(g => <option key={g.modelId} value={g.modelId}>{g.modelId}</option>)}
                        </select>
                        
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <select 
                                value={createForm.platform} onChange={e => setCreateForm({...createForm, platform: e.target.value})} required
                                style={inputStyle}>
                                <option value="">-- Platform --</option>
                                {platforms.map(p => <option key={p} value={p}>{p}</option>)}
                            </select>
                            <button type="button" onClick={handleAddPlatform} style={{...btnStyle, background: '#444'}}>+</button>
                        </div>

                        {/* Adspower Selector (Create) */}
                        <select 
                            value={createForm.adspowerId} 
                            onChange={e => setCreateForm({...createForm, adspowerId: e.target.value})} 
                            style={inputStyle}
                            disabled={!createForm.platform} // Must pick platform first
                        >
                            <option value="">-- Link Adspower Profile --</option>
                            {adsProfiles.map(p => {
                                // Check collision: Is this profile already used for THIS platform?
                                const isUsed = accounts.some(a => a.platform === createForm.platform && a.adspowerId === p.user_id);
                                return (
                                    <option key={p.user_id} value={p.user_id} disabled={isUsed} style={isUsed ? { color: '#888', fontStyle: 'italic' } : {}}>
                                        {p.serial_number} - {p.name} {isUsed ? '(Linked)' : ''}
                                    </option>
                                );
                            })}
                        </select>

                        <input placeholder="Name" required value={createForm.name} onChange={e => setCreateForm({...createForm, name: e.target.value})} style={inputStyle} />
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <input placeholder="Age" required value={createForm.age} onChange={e => setCreateForm({...createForm, age: e.target.value})} style={{...inputStyle, width: '50px'}} />
                            <input placeholder="Location" required value={createForm.location} onChange={e => setCreateForm({...createForm, location: e.target.value})} style={inputStyle} />
                        </div>
                        <input placeholder="TG Handle" required value={createForm.tgHandle} onChange={e => setCreateForm({...createForm, tgHandle: e.target.value})} style={inputStyle} />
                        
                        {/* Model Selector */}
                        <input 
                            list="model-options"
                            placeholder="Model ID (Optional)" 
                            value={createForm.model} 
                            onChange={e => setCreateForm({...createForm, model: e.target.value})} 
                            style={inputStyle} 
                        />
                        <datalist id="model-options">
                            <option value="mistralai/mistral-7b-instruct:free" />
                            <option value="meta-llama/llama-3.3-70b-instruct:free" />
                            <option value="meta-llama/llama-3.2-3b-instruct:free" />
                            <option value="meta-llama/llama-3.1-405b-instruct:free" />
                            <option value="google/gemini-2.0-flash-exp:free" />
                            <option value="google/gemma-3-27b-it:free" />
                            <option value="google/gemma-3-12b-it:free" />
                            <option value="google/gemma-3-4b-it:free" />
                            <option value="google/gemma-3n-e4b-it:free" />
                            <option value="google/gemma-3n-e2b-it:free" />
                            <option value="mistralai/mistral-small-3.1-24b-instruct:free" />
                            <option value="mistralai/devstral-2512:free" />
                            <option value="qwen/qwen-2.5-vl-7b-instruct:free" />
                            <option value="qwen/qwen3-coder:free" />
                            <option value="qwen/qwen3-4b:free" />
                            <option value="nousresearch/hermes-3-llama-3.1-405b:free" />
                            <option value="deepseek/deepseek-r1-0528:free" />
                            <option value="nex-agi/deepseek-v3.1-nex-n1:free" />
                            <option value="openai/gpt-oss-120b:free" />
                            <option value="openai/gpt-oss-20b:free" />
                            <option value="nvidia/nemotron-3-nano-30b-a3b:free" />
                            <option value="nvidia/nemotron-nano-12b-v2-vl:free" />
                            <option value="nvidia/nemotron-nano-9b-v2:free" />
                            <option value="cognitivecomputations/dolphin-mistral-24b-venice-edition:free" />
                            <option value="tngtech/deepseek-r1t-chimera:free" />
                            <option value="tngtech/deepseek-r1t2-chimera:free" />
                            <option value="tngtech/tng-r1t-chimera:free" />
                            <option value="xiaomi/mimo-v2-flash:free" />
                            <option value="arcee-ai/trinity-mini:free" />
                            <option value="kwaipilot/kat-coder-pro:free" />
                            <option value="moonshotai/kimi-k2:free" />
                            <option value="z-ai/glm-4.5-air:free" />
                        </datalist>

                        <textarea placeholder="Persona..." value={createForm.persona} onChange={e => setCreateForm({...createForm, persona: e.target.value})} rows={3} style={{...inputStyle, fontFamily: 'sans-serif'}} />
                        <button disabled={loading} style={btnStyle}>Create</button>
                    </form>
                </div>

                {/* List (Right Panel) */}
                <div style={{ flex: 2, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '10px', alignContent: 'start' }}>
                    {accounts.map(a => (
                        <div key={a.id} style={{ background: '#1e1e1e', padding: '15px', border: '1px solid #444', borderRadius: '4px', position: 'relative' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                <strong style={{ color: '#fff' }}>{a.name}</strong>
                                <span style={{ background: '#007acc', padding: '1px 6px', borderRadius: '3px', fontSize: '0.75rem', color: 'white' }}>{a.modelId}</span>
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#888' }}>{a.location}, {a.age}</div>
                            <div style={{ fontSize: '0.75rem', color: '#aaa', fontStyle: 'italic' }}>
                                {a.platform || 'Unknown'} 
                                {a.adspowerId && <span style={{ color: '#2da44e', marginLeft: '5px' }}>[AdsPower Linked]</span>}
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#00cc66' }}>@{a.tgHandle}</div>

                            <div style={{ display: 'flex', gap: '5px', marginTop: '10px' }}>
                                <button 
                                    onClick={() => toggleBot(a)}
                                    style={{ 
                                        flex: 1, 
                                        padding: '5px', 
                                        background: activeSessions.includes(a.id) ? '#a31515' : '#2da44e', 
                                        color: 'white', 
                                        border: 'none', 
                                        cursor: 'pointer', 
                                        borderRadius: '3px',
                                        fontWeight: 'bold'
                                    }}>
                                    {activeSessions.includes(a.id) ? '⏹ Stop' : '▶ Run'}
                                </button>
                                
                                {activeSessions.includes(a.id) && (
                                    <>
                                        <button 
                                            onClick={() => togglePause(a)}
                                            style={{ 
                                                padding: '5px', 
                                                background: pausedSessions.includes(a.id) ? '#d4af37' : '#444', 
                                                color: 'white', 
                                                border: 'none', 
                                                cursor: 'pointer', 
                                                borderRadius: '3px'
                                            }}>
                                            {pausedSessions.includes(a.id) ? '▶' : '⏸'}
                                        </button>
                                        
                                        <button 
                                            onClick={() => toggleLog(a.id)}
                                            style={{ 
                                                padding: '5px', 
                                                background: visibleLogs.includes(a.id) ? '#007acc' : '#444', 
                                                color: 'white', 
                                                border: 'none', 
                                                cursor: 'pointer', 
                                                borderRadius: '3px'
                                            }}
                                            title="Toggle Brain Log">
                                            📜
                                        </button>
                                    </>
                                )}

                                <button 
                                    onClick={() => setEditingAccount(a)}
                                    style={{ padding: '5px 10px', background: '#333', border: 'none', color: '#ccc', cursor: 'pointer', borderRadius: '3px' }}>
                                    Edit
                                </button>
                            </div>

                            {/* LIVE DEBUG LOG */}
                            {visibleLogs.includes(a.id) && (
                                <div style={{ 
                                    marginTop: '10px', 
                                    padding: '8px', 
                                    background: '#000', 
                                    border: '1px solid #333', 
                                    borderRadius: '4px',
                                    fontSize: '0.7rem',
                                    fontFamily: 'monospace',
                                    color: '#ccc',
                                    height: '200px', 
                                    overflowY: 'auto'
                                }}>
                                    <div style={{ borderBottom: '1px solid #333', marginBottom: '5px', color: '#fff', fontWeight: 'bold' }}>
                                        BRAIN STREAM {debugPayloads[a.id] ? `(${debugPayloads[a.id].timestamp})` : ''}
                                    </div>
                                    
                                    {!debugPayloads[a.id] ? (
                                        <div style={{ color: '#666', fontStyle: 'italic', padding: '10px', textAlign: 'center' }}>
                                            Waiting for next cycle...
                                        </div>
                                    ) : (
                                        <div>
                                            <div style={{ color: '#888' }}>[System Prompt Hidden]</div>
                                            <div style={{ color: '#4ec9b0', margin: '5px 0' }}>History ({debugPayloads[a.id].history_len}):</div>
                                            {debugPayloads[a.id].messages.map((m, i) => (
                                                <div key={i} style={{ marginBottom: '4px', paddingLeft: '5px', borderLeft: m.role === 'user' ? '2px solid #ce9178' : '2px solid #569cd6' }}>
                                                    <span style={{ color: m.role === 'user' ? '#ce9178' : '#569cd6', fontWeight: 'bold' }}>
                                                        {m.role.toUpperCase()}:
                                                    </span> 
                                                    <span style={{ marginLeft: '5px' }}>{m.content}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* --- MODAL: EDIT ACCOUNT --- */}
            {editingAccount && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <h3>Edit: {editingAccount.name}</h3>
                            <button onClick={() => setEditingAccount(null)} style={closeBtnStyle}>✕</button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                            <label>Configuration</label>
                            <select 
                                value={editingAccount.modelId} onChange={e => setEditingAccount({...editingAccount, modelId: e.target.value})}
                                style={{...inputStyle, marginBottom: '5px'}}>
                                {modelGroups.map(g => <option key={g.modelId} value={g.modelId}>{g.modelId}</option>)}
                            </select>
                            <select 
                                value={editingAccount.platform} onChange={e => setEditingAccount({...editingAccount, platform: e.target.value})}
                                style={inputStyle}>
                                <option value="">-- Platform --</option>
                                {platforms.map(p => <option key={p} value={p}>{p}</option>)}
                            </select>

                            <label>Browser Profile</label>
                            <select 
                                value={editingAccount.adspowerId || ''} 
                                onChange={e => setEditingAccount({...editingAccount, adspowerId: e.target.value})} 
                                style={{...inputStyle, marginBottom: '10px'}}
                            >
                                <option value="">-- No Link --</option>
                                {adsProfiles.map(p => {
                                    // Collision check excluding self
                                    const isUsed = accounts.some(a => a.id !== editingAccount.id && a.platform === editingAccount.platform && a.adspowerId === p.user_id);
                                    return (
                                        <option key={p.user_id} value={p.user_id} disabled={isUsed} style={isUsed ? { color: '#888', fontStyle: 'italic' } : {}}>
                                            {p.serial_number} - {p.name} {isUsed ? '(Linked)' : ''}
                                        </option>
                                    );
                                })}
                            </select>

                            <label>Details</label>
                            <input value={editingAccount.name} onChange={e => setEditingAccount({...editingAccount, name: e.target.value})} style={inputStyle} placeholder="Name" />
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <input value={editingAccount.age} onChange={e => setEditingAccount({...editingAccount, age: e.target.value})} style={inputStyle} placeholder="Age" />
                                <input value={editingAccount.location} onChange={e => setEditingAccount({...editingAccount, location: e.target.value})} style={inputStyle} placeholder="Loc" />
                            </div>
                            <input value={editingAccount.tgHandle} onChange={e => setEditingAccount({...editingAccount, tgHandle: e.target.value})} style={inputStyle} placeholder="TG" />
                            
                            <label>AI Model</label>
                            <input 
                                list="model-options"
                                value={editingAccount.model || ''} 
                                onChange={e => setEditingAccount({...editingAccount, model: e.target.value})} 
                                style={{...inputStyle, marginBottom: '10px'}} 
                                placeholder="Default (Global Sandbox)" 
                            />

                            <label>Persona</label>
                            <textarea value={editingAccount.persona} onChange={e => setEditingAccount({...editingAccount, persona: e.target.value})} rows={4} style={{...inputStyle, fontFamily: 'sans-serif'}} />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <button onClick={handleDelete} style={{...btnStyle, background: '#a31515'}}>Delete</button>
                            <button onClick={handleSaveEdit} style={{...btnStyle, background: '#007acc'}}>Save Changes</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// Reusing Styles
const inputStyle = { padding: '8px', background: '#3c3c3c', border: '1px solid #555', color: 'white' };
const btnStyle = { padding: '8px 15px', background: '#2da44e', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '3px' };
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
const modalContentStyle = { background: '#252526', padding: '25px', borderRadius: '8px', width: '450px', border: '1px solid #444', boxShadow: '0 4px 15px rgba(0,0,0,0.5)' };
const closeBtnStyle = { background: 'transparent', border: 'none', color: '#888', fontSize: '1.2rem', cursor: 'pointer' };